import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const StartDate: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="5"
        width="16"
        height="16"
        rx="3"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="4" y="10" width="16" height="2" fill={color} />
      <rect x="7" y="2" width="2" height="6" rx="1" fill={color} />
      <rect x="15" y="2" width="2" height="6" rx="1" fill={color} />
      <path
        d="M10.5128 15.6102L6.81212 12.6497C6.48474 12.3878 6 12.6211 6 13.0403V18.9597C6 19.3789 6.48474 19.6122 6.81212 19.3503L10.5128 16.3898C10.763 16.1896 10.763 15.8104 10.5128 15.6102Z"
        fill={color}
      />
      <path
        d="M1 15C0.447715 15 4.82823e-08 15.4477 0 16C-4.82823e-08 16.5523 0.447715 17 1 17L1 15ZM6 15L1 15L1 17L6 17L6 15Z"
        fill={color}
      />
    </svg>
  );
};

export default StartDate;
